import { Flex, Spacing, Text } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../../../hooks'
import type { InvoicingSettingsSection } from '../../../../enums/invoicingSettingsSection'
import { useTrackInvoicingSettings } from '../../../../hooks/useTrackInvoicingSettings'
import type { DocumentTypeSettingsFormSchema } from '../../types/documentTypeSettingsFormSchema'
import { DocumentTypeSettingsCard } from '../DocumentTypeSettingsCard'
import { DocumentTypeSettingsSwitchRow } from '../DocumentTypeSettingsSwitchRow'

interface DocumentTypeSettingsItemColumnsProps {
  trackingSection: InvoicingSettingsSection
}

export const DocumentTypeSettingsItemColumns = ({
  trackingSection,
}: DocumentTypeSettingsItemColumnsProps): ReactElement => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<DocumentTypeSettingsFormSchema>()
  const { trackInvoicingSettings } = useTrackInvoicingSettings({ section: trackingSection })

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      <Text weight="medium">{t('invoicing_settings.document_type_settings.item_columns')}</Text>
      <DocumentTypeSettingsCard>
        <Flex flexDirection="column" gap={Spacing.S8}>
          <FormItem
            name="isDateColumnVisible"
            render={({ field: { onChange, value } }) => (
              <DocumentTypeSettingsSwitchRow
                checked={value}
                label={t('external_invoices.editor.form.field.line.header.date')}
                onChange={(event) => {
                  onChange(event)
                  trackInvoicingSettings('Item column toggled', { checked: event.target.checked, column: 'date' })
                }}
              />
            )}
          />
          <FormItem
            name="isUnitColumnVisible"
            render={({ field: { onChange, value } }) => (
              <DocumentTypeSettingsSwitchRow
                checked={value}
                label={t('external_invoices.editor.form.field.line.header.unit')}
                onChange={(event) => {
                  onChange(event)
                  trackInvoicingSettings('Item column toggled', { checked: event.target.checked, column: 'unit' })
                }}
              />
            )}
          />
        </Flex>
      </DocumentTypeSettingsCard>
    </Flex>
  )
}
